export type EcardType = 'free' | 'premium';

interface AddEcardUtmParamsOptions {
  ecardType: EcardType;
}

export function addEcardUtmParams(url: string, options: AddEcardUtmParamsOptions): string {
  const { ecardType } = options;

  try {
    const urlObj = new URL(url);

    urlObj.searchParams.set('utm_source', 'joy');
    urlObj.searchParams.set('utm_medium', 'ecard');
    urlObj.searchParams.set('utm_campaign', ecardType === 'premium' ? 'premium-digital' : 'free-digital');

    return urlObj.toString();
  } catch (error) {
    return url;
  }
}

// Re-exported for back-compat. Canonical home is `@shared/utils/guestSiteUrl`.
export { isJoyWebsiteUrl } from '@shared/utils/guestSiteUrl';
